import React from "react";
import ReactTags from "react-tag-autocomplete";

export default class ProxySubnetsWebsites extends React.Component {
    state = {
        websites: [],
        website_suggestions: this.props.websites
    };

    componentDidMount() {
        this.inputRef = React.createRef();
        let websites = [];
        
        this.props.subnet.websites.forEach(website => {
            websites.push({slug: website.id, name: website.website}); 
        });

        this.setState({websites});
    }

    onDelete(i) {
        const websites = this.state.websites.slice(0);
        websites.splice(i, 1);
        this.setState({ websites }, () => {
            this.props.updateSubnet(this.props.subnet);
        });
        
        this.props.toggleCell(this.props.subnet.id, 'websites', websites);
    }

    onAddition(tag) {
        const websites = [].concat(this.state.websites, tag);
        this.setState({ websites }, () => {
            this.props.updateSubnet(this.props.subnet);
        });
    
        this.props.toggleCell(this.props.subnet.id, 'websites', websites);
    }

    render() {
        return (
            <React.Fragment>
                <form autoComplete="off" className="form form--horizontal" >
                    <ReactTags
                        ref={this.inputRef}
                        tags={this.state.websites}
                        allowNew={true}
                        suggestions={this.state.website_suggestions}
                        onDelete={this.onDelete.bind(this)}
                        onAddition={this.onAddition.bind(this)}
                        placeholderText="Add Website" 
                        addOnBlur={true} 
                    />
                </form>
            </React.Fragment>
        );
    }
}
